import api from '@/helpers/api';

import type {
	RescheduleInterviewPayload,
	ScheduleInterviewPayload,
	ScheduleInterviewResponse,
} from '@/components/modal/Profile/scheduleInterview/types';

const scheduleInterview = async (
	workerId: string,
	companyNeedId: string,
	data: ScheduleInterviewPayload
): Promise<ScheduleInterviewResponse> => {
	const response = await api.request({
		url: `/besoins/${companyNeedId}/workers/${workerId}/interviews`,
		method: 'POST',
		data,
	});
	return response.data;
};

const rescheduleInterview = async (
	workerId: string,
	companyNeedId: string,
	interviewId: string,
	data: RescheduleInterviewPayload
): Promise<ScheduleInterviewResponse> => {
	const response = await api.request({
		url: `/besoins/${companyNeedId}/workers/${workerId}/interviews/${interviewId}`,
		method: 'PUT',
		data: {
			date: data.date,
			start: data.start,
			end: data.end,
			contactId: data.contactId,
			comment: data.comment ?? '',
		},
	});
	return response.data;
};

export default {
	scheduleInterview,
	rescheduleInterview,
};
